export default __webpack_public_path__ + "static/media/copy.85c8ade9.svg";